module.exports = "./img/4c9f157254fe5c2bda50b6e08ebc40f0.jpg";